import { AuthProvider } from 'contexts';
import { RouterProvider, ScrollRestoration } from 'react-router-dom';
import router from 'router';
import StyleConfigProvider from 'StyleConfigProvider';
import AxiosComponent from 'utils/axios'
import 'leaflet/dist/leaflet.css';

function App() {
  return (
    <StyleConfigProvider>
      <AuthProvider>
        <AxiosComponent>
          <RouterProvider router={router}>
            <ScrollRestoration />
          </RouterProvider>
        </AxiosComponent>
      </AuthProvider>
    </StyleConfigProvider>
  );
}

export default App;
